import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { fetchDropdowns, prefillArrayFields } from "./utils";
import FormFieldRenderer from "./FormFieldRenderer";
import "./DynamicForm.css";
import { getUser } from "../../pages/Login/authUtils";

const DynamicForm = ({ fields, apiUrl, successRedirect }) => {
  const [formData, setFormData] = useState({});
  const [dropdownData, setDropdownData] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDropdowns(fields, setDropdownData);

    const user = getUser();
    if (user?._id && user?.name) {
      setFormData((prev) => ({
        ...prev,
        CreatedBy: {
          _id: user._id,
          name: user.name,
        },
      }));
    }
  }, [fields]);

  useEffect(() => {
    prefillArrayFields(fields, formData, setFormData);
  }, [fields, formData]);
  

  // const handleInputChange = (e) => {
  //   const { name, value, type } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: type === "number" ? parseInt(value, 10) : value,
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const submissionData = { ...formData };

      // ✅ Always enforce current user _id
      const user = getUser();
      if (user?._id) {
        submissionData.CreatedBy = user._id;
      }

      // ✅ Always remove location field before sending
      for (const field of fields) {
        if (field.type === "location") {
          delete submissionData[field.fields];
        }
      }

      console.log("🟡 Final submissionData:", submissionData); // Optional debug

      await axios.post(apiUrl, submissionData);
      alert("Entry created successfully!");
      navigate(successRedirect);
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dynamic-form">
      <h2 className="form-title">Create New Entry</h2>
      <form onSubmit={handleSubmit}>
        {fields.map((field, idx) => (
          <FormFieldRenderer
            key={idx}
            field={field}
            formData={formData}
            setFormData={setFormData}
            dropdownData={dropdownData}
            readOnly={field.fields === "CreatedBy"}
            displayNameOnly={field.fields === "CreatedBy"} // 👈 Added this
          />
        ))}
        <div className="form-button-wrapper">
          <button className="submit-btn" disabled={loading}>
            {loading ? "Loading..." : "Create Entry"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DynamicForm;
